import { render, staticRenderFns } from "./ConversationReservationFormCard.vue?vue&type=template&id=442a286f&scoped=true&"
import script from "./ConversationReservationFormCard.vue?vue&type=script&lang=js&"
export * from "./ConversationReservationFormCard.vue?vue&type=script&lang=js&"
import style0 from "./ConversationReservationFormCard.vue?vue&type=style&index=0&id=442a286f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a286f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VRow,VSelect,VTextarea})
